<div class="row">
    <div
        *ngIf="!(detailsHistory$ | async); else content"
        style="height: 100vh"
        class="my-3"
    >
        <p-skeleton width="100%" height="90%"></p-skeleton>
    </div>
    <ng-template #content>
        <div
            class="ressource_wrapper"
            *ngIf="detailsHistory$ | async as currentEvent"
        >
            <div class="identification">
                <div class="row mt-3">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label><b>Date/Heure</b></label>
                            <input
                                type="text"
                                [value]="currentEvent?.created_at ?? ''"
                                disabled
                                pInputText
                            />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label><b>Utilisateur</b></label>
                            <input
                                type="text"
                                value="{{
                                    currentEvent?.initiePar?.last_name ?? ''
                                }} {{ currentEvent?.initiePar?.first_name ?? '' }}"
                                disabled
                                pInputText
                            />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label><b>Adresse IP</b></label>
                            <input
                                type="text"
                                [value]="currentEvent?.ip_address ?? ''"
                                disabled
                                pInputText
                            />
                        </div>
                    </div>
                </div>
                <div class="row my-3">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label><b>Action</b></label>
                            <input
                                type="text"
                                [value]="currentEvent?.action ?? ''"
                                disabled
                                pInputText
                            />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label><b>Module</b></label>
                            <input
                                type="text"
                                [value]="currentEvent?.module ?? ''"
                                disabled
                                pInputText
                            />
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label><b>Moyen d'accès</b></label>
                            <input
                                type="text"
                                [value]="currentEvent?.agent_use ?? ''"
                                disabled
                                pInputText
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="table_wrapper"
            *ngIf="(detailsHistory$ | async)?.type_action === 'Mise à jour'"
        >
            <table class="native_table table">
                <thead>
                    <tr>
                        <th style="width: 35rem" style="text-align: center">
                            Champs
                        </th>
                        <th style="text-align: center">Valeurs Avant</th>
                        <th style="text-align: center">Valeurs Après</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of transformedUpdateData$ | async">
                        <td>{{ item?.key || '-' }}</td>
                        <td>{{ item?.previousValue || '-' }}</td>
                        <td>{{ item?.currentValue || '-' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div
            class="table_wrapper"
            *ngIf="(detailsHistory$ | async)?.type_action !== 'Mise à jour'"
        >
            <table class="native_table table">
                <thead>
                    <tr>
                        <th style="width: 35rem" style="text-align: center">
                            Champs
                        </th>
                        <th style="text-align: center">Valeurs</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of transformedUpdateData$ | async">
                        <td>{{ item?.key || '-' }}</td>
                        <td>{{ item?.value || '-' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-template>
</div>
